import styled from "styled-components";

import * as css from "styles/CssVariables.js";
import globalConstants from "constants/globalConstants";
import {
  dateFormatted,
  getTimeAMPM,
  numberWithCommas,
} from "modules/functions";

import fastStartIcon from "assets/img/icons/fast-start-icon.svg";
import coinsIcon from "assets/img/icons/coins-icon.svg";

const BonusBox = styled.div`
  margin-top: ${css.VERTICAL_BOX_MARGIN_LARGE};

  width: 100%;
  padding: ${css.BOX_PADDING_SECONDARY};
  box-sizing: border-box;

  background: ${css.BRAND_INDIGO};
  border-radius: ${css.BOX_RADIUS_SECONDARY};

  display: flex;
  flex-direction: row;
  gap: 16px;

  @media (max-width: ${globalConstants.switchMobile}) {
    flex-direction: column;
    gap: 8px;
  }
`;

const BonusTitleIcon = styled.div`
  width: 60px;
  min-width: 60px;
  height: 60px;

  @media (max-width: ${globalConstants.switchMobile}) {
    width: 54px;
    min-width: 54px;
    height: 54px;
  }
`;

const BonusBoxContent = styled.div`
  padding-top: 6px;

  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN};
`;

const BonusTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const BonusTitleText = styled.div`
  font-size: 20px;
  font-weight: 500;

  white-space: break-spaces;
`;

const StatusBadge = styled.div`
  height: 20px;
  padding: 0 14px 1px;

  font-size: 13px;

  border-radius: 10px;
  background: ${css.BRAND_GREEN};

  display: flex;
  justify-content: center;
  align-items: center;
`;

const BonusText = styled.div`
  line-height: 130%;
`;

const BonusData = styled.div`
  padding-bottom: 6px;

  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const BonusDataLine = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const BonusDataText = styled.div`
  font-weight: 500;
`;

const BonusDataIcon = styled.div`
  width: 24px;
  min-width: 24px;
  height: 24px;
`;

export default ({ data }) => {
  const { coinsFound, progress, expires, limit, amount } = data.fastStartData;

  return (
    <BonusBox>
      <BonusTitleIcon>
        <img src={fastStartIcon} style={{ width: "100%" }} />
      </BonusTitleIcon>
      <BonusBoxContent>
        <BonusTitle>
          <BonusTitleText>${amount} Fast Start Bonus</BonusTitleText>
          <StatusBadge>Active</StatusBadge>
        </BonusTitle>
        <BonusText>
          Find at least {numberWithCommas(limit)} Coins within the first 24
          hours of registration and receive a ${amount} USD bonus!
        </BonusText>
        {data && (
          <BonusData>
            <BonusDataLine>
              <BonusDataText>Coins found:</BonusDataText>
              <BonusDataIcon>
                <img src={coinsIcon} style={{ width: "100%" }} />
              </BonusDataIcon>
              <BonusDataText>
                {coinsFound}/{numberWithCommas(limit)} ({progress}%)
              </BonusDataText>
            </BonusDataLine>
            <BonusDataLine>
              <BonusDataText>Expires: </BonusDataText>
              <BonusDataText>
                {dateFormatted(new Date(expires), false) +
                  ", " +
                  getTimeAMPM(new Date(expires))}
              </BonusDataText>
            </BonusDataLine>
          </BonusData>
        )}
      </BonusBoxContent>
    </BonusBox>
  );
};
